import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
// No idea why this happens...
// eslint-disable-next-line import/order
import createCompressor from "redux-persist-transform-compress";

import {
  autofocusFieldSlice,
  draggingIdSlice,
  incomingTemplateSlice,
  isDragAndDropDraggingSlice,
  lastReadUpdateSlice,
  librarySlice,
} from "./reducer";

const compressor = createCompressor();
export const store = configureStore({
  reducer: {
    library: persistReducer(
      {
        key: "library",
        storage,
        transforms: [compressor],
      },
      librarySlice.reducer
    ),
    incomingTemplate: incomingTemplateSlice.reducer,
    autofocusField: autofocusFieldSlice.reducer,
    draggingId: draggingIdSlice.reducer,
    isDragAndDropDragging: isDragAndDropDraggingSlice.reducer,
    lastReadUpdate: persistReducer(
      {
        key: "lastReadUpdate",
        storage,
        transforms: [],
      },
      lastReadUpdateSlice.reducer
    ),
  },
});

export const persistor = persistStore(store);

export type ReduxState = ReturnType<typeof store.getState>;
export type ReduxDispatch = typeof store.dispatch;
